export default {
  computed: {},
  methods: {
    checkSubscriptionStatus(companyId) {
      return this.$fetch.get(
        `/api/v1/companies/${companyId}/subscription_status`,
      );
    },

    // remember: keep the session for 14 days (the API token's lifespan) instead of 12 hours.
    async setAuth(response, { remember = false } = {}) {
      const redirectTo = this.redirectAfterAuth || this.$route.params.redirectTo;

      const sessionDurationMs = remember ? 14 * 86400000 : 43200000;
      const timestampMsNow = this.$moment().valueOf();

      const user = response.data.data;
      // axios 1.x returns AxiosHeaders (lowercase keys); a plain object is what the store keeps.
      const headers = typeof response.headers.toJSON === "function" ? response.headers.toJSON() : response.headers;
      const session = {
        authTime: timestampMsNow,
        expireAt: timestampMsNow + sessionDurationMs,
      };

      const company = user.company;

      this.$store.dispatch("Companies/setCompany", company);

      this.$store.dispatch("App/setHeaders", headers);

      this.$store.dispatch("App/setSession", session);

      this.$store.dispatch("App/setUser", user);

      this.$ability.update(this.$helpers.processRules(user.rules));

      try {
        const { data: subscriptionStatus } = await this.checkSubscriptionStatus(
          company.id,
        );

        if (
          subscriptionStatus &&
          subscriptionStatus.attributes &&
          subscriptionStatus.attributes.suspended
        ) {
          this.$router.push(
            {
              name: "SubscriptionSuspended",
              query: {
                a:
                  user.account_type === "system_admin"
                    ? "68ed1c7decda36085c86df62823cde17"
                    : "d63c7ede8cb1e1c8db5e51c63fd47cff",
              },
            },
            () => {},
            () => {},
          );
          return;
        }
      } catch (error) {
        console.error("Error checking subscription status:", error);
        // Continue with normal flow if subscription check fails
      }

      // Proceed with routing based on onboarding status
      if (user.onboarding_completed) {
        if (redirectTo) {
          // A string keeps the query (?note=1, ?ditar=1 from the e-mails); { path } drops it.
          this.$router.replace(redirectTo).catch(() => {});
        } else {
          this.$router.replace(
            { name: "Customers" },
            () => {},
            () => {},
          );
        }
      } else {
        this.$router.replace(
          { name: "OnboardingSpecialty" },
          () => {},
          () => {},
        );
      }
    },
  }, //methods
  watch: {}, //watch
  beforeRouteEnter(to, from, next) {
    next((vm) => {});
  }, //beforeRouteEnter
  beforeRouteUpdate(to, from, next) {
    next();
  }, //beforeRouteUpdate
  beforeRouteLeave(to, from, next) {
    next();
  }, //beforeRouteLeave
  created() {}, //created
  beforeMount() {}, //beforeMount
  mounted() {}, //mounted
};
